if (!customElements.get('woenix-kit')) customElements.define('woenix-kit',class extends HTMLElement {
connectedCallback(){if(this.started)return;this.started=true;this.load();}
async load(){try{
const mappings={
'Cricket Bats':['Bat Care','Bat Grips','Bat Covers','Batting Gloves'],
'Batting Gloves':['Batting Pads','Thigh Guards','Cricket Bats'],
'Batting Pads':['Batting Gloves','Thigh Guards','Abdominal Guards'],
'Cricket Helmets':['Neck Guards','Batting Gloves','Thigh Guards'],
'Cricket Shoes':['Shoe Accessories','Sports Supports','Kit Bags'],
'Cricket Balls':['Cricket Bats','Training Equipment','Bat Grips'],
'Wicket Keeping Gloves':['Wicket Keeping Inner Gloves','Cricket Helmets','Kit Bags'],
'Thigh Guards':['Abdominal Guards','Batting Gloves','Batting Pads'],
'Bat Care':['Bat Grips','Bat Covers','Cricket Bats'],
'Bat Grips':['Bat Care','Bat Covers','Cricket Bats'],
'Abdominal Guards':['Thigh Guards','Batting Gloves','Batting Pads']
};
const types=mappings[this.dataset.type]||['Batting Gloves','Cricket Balls','Kit Bags'];
const quote=s=>'"'+s.replace(/["\\]/g,'\\$&')+'"';
const typeQuery='('+types.map(t=>'product_type:'+quote(t)).join(' OR ')+')';
const get=async q=>{
const url=new URL(this.dataset.search,location.origin);
url.searchParams.set('q',q);url.searchParams.set('type','product');url.searchParams.set('view','woenix-kit');url.searchParams.set('options[unavailable_products]','hide');url.searchParams.set('options[prefix]','none');
const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)return [];
const doc=new DOMParser().parseFromString(await response.text(),'text/html');return Array.from(doc.querySelectorAll('[data-kit-card]'));
};
let candidates=await get('vendor:'+quote(this.dataset.brand)+' AND '+typeQuery);
if(candidates.length<4)candidates.push(...await get(typeQuery));
const seen=new Set();candidates=candidates.filter(c=>{const id=c.dataset.product;if(id===this.dataset.product||seen.has(id)||!types.includes(c.dataset.type)||c.dataset.type===this.dataset.type)return false;seen.add(id);return true;});
for(let i=candidates.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[candidates[i],candidates[j]]=[candidates[j],candidates[i]];}
candidates.sort((a,b)=>Number(b.dataset.brand===this.dataset.brand)-Number(a.dataset.brand===this.dataset.brand));
const chosen=[];const usedTypes=new Set();
for(const c of candidates){if(!usedTypes.has(c.dataset.type)){chosen.push(c);usedTypes.add(c.dataset.type);}if(chosen.length===4)break;}
for(const c of candidates){if(chosen.length===4)break;if(!chosen.includes(c))chosen.push(c);}
if(!chosen.length)return;this.querySelector('.woenix-kit__items').replaceChildren(...chosen);this.hidden=false;
}catch(e){this.hidden=true;}}
});